<template>
    <div class="modal fade" id="installIosModal" ref="installIosModal" tabindex="-1" role="dialog" aria-labelledby="installIosModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" style="background-color: ##FFFFFF;">
                <div class="modal-header">
                    <button @click="preventSevenDays()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h5 id="installIosModalLabel" class="note-text-add-to-homescreen-title">{{ $t('pwa.modals.innstall_title') }}</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <span class="note-text-add-to-homescreen" v-html="$t('pwa.modals.note_ios')"></span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row w-100">
                        <div class="col-7">
                            <div data-dismiss="modal" class="modal-footer-canvassing-add-homescreen-button green-btn text-center cursor-pointer">
                                {{ $t('pwa.modals.remind_me_later') }}
                            </div>
                        </div>
                        <div class="col-5">
                            <div @click="preventSevenDays()" data-dismiss="modal" class="modal-footer-canvassing-add-homescreen-button text-center cursor-pointer">
                                {{ $t('pwa.modals.cancel') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import Vue from 'vue';
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: 'InstallIosModal',
        props: [
        ],
        mixins: [HelperMixin],
        data() {
            return {
                hiddenSevenDaysIos: this.checkCookie('hidehomescreenbarios') ? true : false,
                isIosVar: false,
                isMobile: false,
                isInstalledIos: false
            }
        },
        created() {
            this.isIos();
            this.isMobileFct();
            if (window.matchMedia('(display-mode: standalone)').matches) {
                this.isInstalledIos = true;
            }
            this.canShowInstallAppFctIos();
        },
        methods: {
            canShowInstallAppFctIos() {
                if (!this.isInstalledIos && this.isMobile && this.isIosVar == true && this.hiddenSevenDaysIos == false) {
                    this.$nextTick(function() {
                        $('#installIosModal').modal('show');
                    });
                    
                } else {
                    this.$nextTick(function() {
                        $('#installIosModal').modal('hide');
                    });
                }
                this.$forceUpdate();
            },

            isMobileFct() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                // true for mobile device
                this.isMobile = true;
                }else{
                // false for not mobile device
                this.isMobile = false;
                }
            },

            preventSevenDays() {
                this.hiddenSevenDaysIos = true;
                this.setCookie('hidehomescreenbarios', true, 7);
                this.canShowInstallAppFctIos();
            },

            isIos() {
                // Detects if device is on iOS 
                const isIos = () => {
                const userAgent = window.navigator.userAgent.toLowerCase();
                    return /iphone|ipad|ipod/.test( userAgent );
                }
                // Detects if device is in standalone mode
                const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
                // Checks if should display install popup notification:
                if (isIos() && !isInStandaloneMode()) {
                    this.isIosVar = true;
                } else {
                    this.isIosVar = false;
                }
            },
        }
    }
</script>
<style scoped>
.note-text-add-to-homescreen-title {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    color: #000000;
}
.note-text-add-to-homescreen {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #000000;
}
.modal-footer-canvassing-add-homescreen-button {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    color: #000000;
}
.green-btn {
    color: #7EB826 !important;
}
</style>